module.exports = __webpack_public_path__ + "img/4@2x.b9175c04.png";